import UISettings from './UISettings'

export default UISettings
